import AdminVaspsSubHeader from './AdminVaspsSubHeader'

export default AdminVaspsSubHeader
